import { render, staticRenderFns } from "./TranslationEntry.vue?vue&type=template&id=ff3e00f6&"
import script from "./TranslationEntry.vue?vue&type=script&lang=js&"
export * from "./TranslationEntry.vue?vue&type=script&lang=js&"
import style0 from "./TranslationEntry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
